import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function SelectComponent({ value, setValue, data, className }) {
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div className={className}>
      <Box
        sx={{
          maxWidth: 120,
          minWidth: 120,
        }}
      >
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Language</InputLabel>
          <Select
            defaultValue={data[0]}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            label="Language"
            onChange={handleChange}
          >
            {data.map((item) => (
              <MenuItem key={item.name} value={item}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </div>
  );
}

export default SelectComponent;
